import React from "react";

interface SliderTooltipProps {
  children: React.ReactNode;
  theme: any;
}

const SliderTooltip: React.FC<SliderTooltipProps> = ({ children }) => {
  const themeTooltip = {
    transform: "translate(-50%, -10px)",
  };

  return (
    <div
      className="min-w-[80px] text-center text-white bg-slate-700 bottom-full relative text-xs rounded-sm"
      style={themeTooltip}
    >
      {children}
    </div>
  );
};

export default SliderTooltip;
